import axios from 'axios';

export const STRAPI_URL = 'https://strapi.coolbit.ai';

export const strapi = axios.create({
  baseURL: STRAPI_URL,
});
